module.exports = __webpack_public_path__ + "static/media/newsletter-december-2021-feast-day.828c1ebb.jpg";